import * as React from "react";

/** A modal's placeholder for a list it cannot show yet: loading, empty, failed. */
export const Notice: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="flex h-24 items-center justify-center rounded-xl border border-slate-200 text-sm text-text-subtle">
    {children}
  </div>
);
